export default {
	title: "Whats this?",
};
